import { render, staticRenderFns } from "./UsuarioAplicacionFormBase.vue?vue&type=template&id=f96acecc&"
import script from "./UsuarioAplicacionFormBase.vue?vue&type=script&lang=js&"
export * from "./UsuarioAplicacionFormBase.vue?vue&type=script&lang=js&"
import style0 from "./UsuarioAplicacionFormBase.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./UsuarioAplicacionFormBase.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
